"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var useCsvTable = function useCsvTable(args) {
  var handleFile = function handleFile(file) {
    if (window.FileReader) {
      // FileReader are supported.
      getAsText(file);
    } else {
      alert('FileReader are not supported in this browser.');
    }
  };
  var getAsText = function getAsText(fileToRead) {
    var reader = new FileReader();
    reader.onload = loadHandler;
    reader.onerror = errorHandler;
    if (typeof args.file === 'string') {
      fetch(fileToRead, {
        headers: {
          Authorization: 'Bearer MTcwMw.MutvUmFFfQPaabb0mhtEbrXOdPz0AO9wi8N7LEFoGqb_QXUIziTOpbeylip1'
        }
      }).then(function (res) {
        return res.blob();
      }).then(function (value) {
        var file = new File([value], 'csv', {
          type: value.type
        });
        reader.readAsDataURL(file);
      });
    } else {
      reader.readAsText(fileToRead);
    }
  };
  var loadHandler = function loadHandler(event) {
    var _event$target;
    var csv = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result;
    if (csv) {
      processData(csv);
    }
  };
  var errorHandler = function errorHandler(event) {
    var _event$target2, _event$target2$error;
    if (((_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : (_event$target2$error = _event$target2.error) === null || _event$target2$error === void 0 ? void 0 : _event$target2$error.name) == 'NotReadableError') {
      alert('Cannot read file !');
    }
  };
  function dataUrItoBlob(dataUri) {
    debugger;
    var binary = atob(dataUri.split(',')[1]);
    var mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {
      type: mimeString
    });
  }
  var processData = function processData(csv) {
    var allTextLines = csv.split(/\r\n|\n/);
    var lines = [];
    while (allTextLines.length) {
      var _allTextLines$shift;
      lines.push((_allTextLines$shift = allTextLines.shift()) === null || _allTextLines$shift === void 0 ? void 0 : _allTextLines$shift.split(','));
    }
    // drawOutput(lines);
  };

  (0, _react.useEffect)(function () {
    handleFile(args.file);
  }, [args.file]);
};
var _default = useCsvTable;
exports["default"] = _default;